import { useRouter } from '@abyss/web/hooks/useRouter';
import React, { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { getGeoLocationFromStorage } from '../../common/PSXHeader/SearchBar/utils';
import { useGuestStore } from '../../store/useGuestStore';
import { GuestState } from '../../store/useGuestStore/guestStore';
import { getIsIFPEarlyPay } from '../../utils/guest.utils';

export const GuestSetLocation = () => {
  const { navigate } = useRouter();

  const { guestData } = useGuestStore(
    useShallow((state: GuestState) => ({
      guestData: state.guestData,
    }))
  );

  const geoLocationData = getGeoLocationFromStorage();

  const navigateToGuestFlow = () => {
    if (getIsIFPEarlyPay(guestData)) {
      navigate('/search-results/');
    }
  };

  useEffect(() => {
    if (geoLocationData?.id) {
      navigateToGuestFlow();
    }
  }, []);

  return <div data-testid="guest-set-location"></div>;
};
